/**
 * Decode the provided base64 string to a JSON object
 *
 * @param base64 The base-64 encoded JSON string
 * @returns
 * Returns the parsed JSON object from the base64 string. If there are errors
 * during the decoding process or during JSON parsing, this will return `false`
 * instead.
 */
export const base64ToJson = (base64: string) => {
  try {
    const decodedItems = window.atob(base64);
    const jsonItems = JSON.parse(decodedItems);
    return jsonItems;
  } catch (e) {
    console.error(e);
  }

  return false;
};

/**
 * Encode the provided JSON object to a base64 string
 *
 * @param jsonObject The JSON object to encode
 * @returns
 * Returns the base64 encoded, strigified JSON. If there are errors
 * during the encoding process or during JSON stringify,
 * this will return `false` instead.
 */
export const jsonToBase64 = (jsonObject: any) => {
  try {
    const jsonString = JSON.stringify(jsonObject);
    const base64String = window.btoa(jsonString);
    return base64String;
  } catch (e) {
    console.error(e);
  }

  return false;
};
